import OnboardingFlow from './OnboardingFlow.store';

const defaultState = {};

const mutations = {};

const actions = {};

export default {
  namespaced: true,
  state: { ...defaultState },
  mutations,
  actions,
  modules: {
    OnboardingFlow
  }
};
